import { toast, ToastOptions } from "react-toastify";
import Toast from "../components/Toast/Toast.component";

interface ToastService {
  default: ToastOptions;
  info: (title: string, message?: string, override?: ToastOptions) => void;
  infoAlt: (title: string, message?: string, link?: string, linkText?: string, override?: ToastOptions) => void;
  success: (title: string, message?: string, override?: ToastOptions) => void;
  error: (title: string, message?: string, override?: ToastOptions) => void;
}

const ToastService: ToastService = {
  default: {
    hideProgressBar: true,
    closeButton: false,
    draggable: false,
    icon: false,
  },
  info: (title: string, message?: string, override?: ToastOptions) =>
    toast.info(<Toast title={title} message={message} style="info" />, {
      ...ToastService.default,
      ...override,
    }),
  infoAlt: (title: string, message?: string, link?: string, linkText?: string, override?: ToastOptions) =>
    toast.info(<Toast title={title} message={message} style="success" link={link} linkText={linkText} />, {
      ...ToastService.default,
      ...override,
    }),
  success: (title: string, message?: string, override?: ToastOptions) =>
    toast.success(<Toast title={title} message={message} style="success" />, {
      ...ToastService.default,
      ...override,
    }),
  error: (title: string, message?: string, override?: ToastOptions) =>
    toast.error(<Toast title={title} message={message} style="error" />, {
      ...ToastService.default,
      ...override,
    }),
};

export default ToastService;
